import { ListItem, Typography } from '@mui/material'

import { CenteredLoading } from '../CenteredLoading/CenteredLoading'

export const LoadingListItem = ({ loading }: { loading: boolean }) => {
  return (
    <>
      {loading && (
        <ListItem disablePadding sx={{ justifyContent: 'center' }}>
          <CenteredLoading />
        </ListItem>
      )}
    </>
  )
}

export const NoResultListItem = ({ noResult }: { noResult: boolean }) => {
  return (
    <>
      {noResult && (
        <ListItem sx={{ justifyContent: 'center' }}>
          <Typography>No match found</Typography>
        </ListItem>
      )}
    </>
  )
}
export const NoSelectedListItem = ({ noResult }: { noResult: boolean }) => {
  return (
    <>
      {noResult && (
        <ListItem sx={{ justifyContent: 'center' }}>
          <Typography>No selected services</Typography>
        </ListItem>
      )}
    </>
  )
}
